export default __webpack_public_path__ + "static/media/WebsRobots2.2e9d8cc1.jpg";